import { cn } from '../../lib/cn';
import type { ModuleAcceptanceRow } from '../../enterpriseacceptance/framework';

type Props = { modules?: ModuleAcceptanceRow[] };

export function ModuleAcceptancePanel({ modules = [] }: Props) {
  return (
    <div className="space-y-2">
      {modules.map((m) => (
        <div key={m.module} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{m.category}</p>
              <p className="text-xs text-slate-500">{m.module}</p>
            </div>
            <div className="text-right">
              <p className="text-sm font-semibold">{m.score}%</p>
              <span className={cn(
                'text-xs font-medium',
                m.status === 'certified' ? 'text-success-600' : 'text-brand-600',
              )}>
                {m.status.replace('_', ' ')}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
